let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("49R0z")).then(() => parcelRequire('2D505'));